/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { createSelector } from 'reselect';

export const getMfeCheckoutState = (state) => state?.mfeCheckout;

export const getIsCheckoutReducerLoaded = (state) => {
    const mfeCheckout = getMfeCheckoutState(state);

    if (mfeCheckout) {
        return true;
    }

    return false;
};

export const getFeatureFlags = (state) => {
    const mfeCheckout = getMfeCheckoutState(state);
    return mfeCheckout?.app?.featureFlags || {};
};

export const getBrandConfig = (state) => {
    const mfeCheckout = getMfeCheckoutState(state);

    return mfeCheckout?.app?.config || {};
};

export const getCheckoutAppConfigLoaded = (state) => {
    const flags = getFeatureFlags(state);
    const config = getBrandConfig(state);

    if (Object.keys(flags).length > 0 && Object.keys(config).length > 0) {
        return true;
    }

    return false;
};

export const getFeatureFlag = (selector) => createSelector(
    [getFeatureFlags],
    (featureFlags) => {
        if (Array.isArray(selector)) {
            let result = featureFlags;
            // eslint-disable-next-line consistent-return
            selector.forEach((propertyName) => {
                // eslint-disable-next-line no-prototype-builtins
                if (!result?.hasOwnProperty || !result.hasOwnProperty(propertyName)) {
                    return false;
                }
                result = result[propertyName];
            });

            return result;
        }

        if (featureFlags) {
            return featureFlags[selector] ?? false;
        }

        return false;
    },
);

export const getCheckoutFeatureFlags = (state) => state?.checkout?.app?.featureFlags || {};
